  
export var completeQuestionnaire = {
  answers: {
    'q1': "yes",
    'q2': "2",
    'q3': "four",
    'q4': "@5",
    'q5': "@5",
    'q6': "26",
  }
}

export default completeQuestionnaire